const cabData = [
  {
    _id: '656c9f99f612fd9266f99472',
    route: 'njp_bagdogra',
    rate: 2000,
    cab_type: 'seadan/hatchback',
    capacity: 3,
  },
  {
    _id: '656c9f18f612fd9266f99471',
    route: 'njp_kalimpong',
    rate: 4500,
    cab_type: 'seadan/hatchback',
    capacity: 3,
  },
  {
    _id: '656ca3cff612fd9266f99474',
    route: 'njp_kalimpong',
    rate: 5000,
    cab_type: 'SUV',
    capacity: 5,
  },
  {
    _id: '655f5756d60d1a0d81cd1472',
    route: 'darjeeling_njp',
    rate: 4999,
    cab_type: 'seadan/hatchback',
    capacity: 3,
  },
  {
    _id: '656c9eddf612fd9266f99470',
    route: 'njp_gangtok',
    rate: 4999,
    cab_type: 'seadan/hatchback',
    capacity: 3,
  },
  {
    _id: '656ca445f612fd9266f99475',
    route: 'njp_gangtok',
    rate: 6800,
    cab_type: 'SUV',
    capacity: 5,
  },
  {
    _id: '6561ee55d60d1a0d81cd1474',
    route: 'njp_darjeeling',
    rate: 5999,
    cab_type: 'suv',
    capacity: 5,
  },
  {
    _id: '6561edf9d60d1a0d81cd1473',
    route: 'njp_darjeeling',
    rate: 4999,
    cab_type: 'seadan/hatchback',
    capacity: 3,
  },
  {
    _id: '656ca1f7f612fd9266f99473',
    route: 'njp_bagdogra',
    rate: 2800,
    cab_type: 'SUV',
    capacity: 5,
  },
];

export default cabData;
